import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/** Sends a GA4 page_view on every route change (the SPA only loads the tag once). */
const PageViewTracker: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Let the page set its <title> first.
    const t = window.setTimeout(() => trackPageView(pathname), 0);
    return () => window.clearTimeout(t);
  }, [pathname]);
  return null;
};

export default PageViewTracker;
